<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">
        Bloquear o desbloquear tarjeta
      </b-card-header>

      <b-card-body v-if="model.noState">
        <div class="col-md-12 text-center">
          <img
            src="@/assets/tjt_lock.png"
            style="max-width: 250px; max-height: 250px"
          />

          <h1 style="color: #ff5855">
            Por el momento tu tarjeta no esta operativa
          </h1>

          <div class="col-md-12">
            <label>
              Por cualquier consulta comunicarse con mesa de ayuda <br />
            </label>
          </div>
        </div>
        <div>
          <div class="row text-left" style="margin-top: 10px">
            <div class="col-md-6">
              <b-button class="btn btn-lg btn-danger" @click="goBack"
                >Volver</b-button
              >
            </div>
          </div>
        </div>
      </b-card-body>

      <b-card-body v-if="!model.noState">
        <div class="col-md-12 text-center">
          <img
            src="@/assets/tjt_lock.png"
            v-if="!model.isLocked"
            style="max-width: 250px; max-height: 250px"
          />
          <img
            src="@/assets/tjt_unlock.png"
            v-if="model.isLocked"
            style="max-width: 250px; max-height: 250px"
          />

          <h1 style="color: #ff5855" v-if="!model.isLocked">
            ¿Querés bloquear la tarjeta?
          </h1>
          <h1 style="color: #ff5855" v-if="model.isLocked">
            ¿Querés desbloquear la tarjeta?
          </h1>

          <div class="col-md-12">
            <label>
              Este bloqueo permite que tu tarjeta no se <br />
              pueda utilizar hasta que la desbloquees, y<br />
              podes hacerlo en cualquier momento
            </label>
          </div>
        </div>
        <div>
          <div class="row text-left" style="margin-top: 10px">
            <div class="col-md-6">
              <b-button class="btn btn-lg btn-danger" @click="goBack"
                >Volver</b-button
              >
            </div>
            <div class="col-md-6 text-right">
              <save-button
                :text="model.textBoton"
                @click="requestLock"
              ></save-button>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import generalHelpers from "@/helpers/generalHelpers";

import JsonCSV from "vue-json-csv";
Vue.component("downloadCsv", JsonCSV);

export default {
  components: {},
  data() {
    return {
      model: {
        stateId: 0,
        viewResult: false,
        isLocked: false,
        noState: false,
        textBoton: "Bloquear"
      },
      resultado: {
        Texto: "",
        Tipo: "success",
        Icono: "fa fa-fw fa-thumbs-up",
      },
      estados: {
        operativa: this.$store.getters.IDEstadoTajetaMsrdOperativa,
        congelada: this.$store.getters.IDEstadoTajetaMsrdCongelada,
      },
    };
  },
  methods: {
    filtrar() {
      let context = this;
      var req = {};
      axiosHelpers.axiosPost("Mastercard/CardState", req, this, function (
        data
      ) {
        context.model.stateId = data.ResponseVM.StateID;
        // -- Indica que la tarjeta no esta en un estado "correcto" para la pantalla
        context.model.noState = (context.model.stateId != context.estados.operativa && context.model.stateId != context.estados.congelada);
        context.model.isLocked = !(context.model.stateId == context.estados.operativa);

          if(context.model.isLocked)
          context.model.textBoton="Desbloquear";
          else
          context.model.textBoton="Bloquear";
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    requestLock() {
      let context = this;

      var req = { CardStateID: context.model.stateId };

      axiosHelpers.axiosPost("Mastercard/ChangeCardState", req, this, function (
        data
      ) {
                    context.filtrar();
        if (data.ResponseVM.Result) {
          notificationHelpers.showSuccess(
            "Correcto",
            "La operación se realizó correctamente",
            context
          );

        }
      });
    },
  },
  beforeMount: function () {
    let context = this;

    context.filtrar();
  },
  mounted: function () {},
  watch: {},
};
</script>